import React, { useState } from 'react'
import { ImportPreviewTable, ColumnProps } from 'components/ImportPreviewTable'
import { Card, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { useMutation } from 'redux-query-react'
import { getActiveClient, getEntities } from 'app/selectors'
import { useSelector } from 'react-redux'
import { transactionsCsvImport } from 'api'
import { useHistory } from 'react-router-dom'
import { FormServerErrors } from 'components/FormServerErrors'
import { formatCurrency, ArrayFirstItemFormatter } from 'utilities'

export const TransactionPreview = () => {
  const [selectedRows, setSelectedRows] = useState([])
  const activeClient = useSelector(getActiveClient)
  const previewCsvTransactions = useSelector((state) => getEntities(state).previewCsvTransactions) || []
  const [errors, setErrors] = useState([] as string[])
  const [importComplete, setImportComplete] = useState(false)
  const history = useHistory()

  function getNonSelectableRows() {
    const nonSelectableRows: number[] = []
    previewCsvTransactions?.forEach((record) => {
      if (!record.valid) {
        nonSelectableRows.push(record.id)
      }
    })
    return nonSelectableRows
  }

  const [{ isPending }, doMutation] = useMutation((selectedRows: any) => {
    return transactionsCsvImport({
      transactionsImport: {
        clientId: activeClient.id,
        selectedTransactions: selectedRows,
      },
    })
  })

  const handleValidSubmit = () => {
    doMutation(selectedRows)?.then((response) => {
      setErrors(response?.body?.errors || [])
      if (response?.body?.status === 200) {
        setImportComplete(true)
      }
    })
  }

  const handleClickAcknowledge = () => {
    history.push(`/client/customers`)
  }

  const columns: ColumnProps[] = [
    {
      dataField: 'select',
      text: '',
    },
    {
      dataField: 'customIdentifier',
      text: 'Custom Identifier',
    },
    {
      dataField: 'amount',
      text: 'Amount',
    },
    {
      dataField: 'date',
      text: 'Process Date',
    },
    {
      dataField: 'comment',
      text: 'Comment',
    },
    {
      dataField: 'frequency',
      text: 'Frequency',
    },
    {
      dataField: 'installments',
      text: 'Installments',
    },
    {
      dataField: 'errors',
      text: 'Errors',
      formatter: ArrayFirstItemFormatter,
    },
  ]

  const callback = (total, invoice) => {
    return total + Number(invoice['amount'].replace(/,| /g, ''))
  }
  const invoiceTotal = selectedRows.reduce(callback, 0)

  return (
    <>
      <Modal isOpen={importComplete}>
        <ModalHeader>Transactions Imported</ModalHeader>
        <ModalBody>
          <p className="mb-0">
            {selectedRows.length === 1
              ? `1 transaction was successfully imported totalling ${formatCurrency(invoiceTotal)}.`
              : `${selectedRows.length} transactions were successfully imported totalling ${formatCurrency(
                  invoiceTotal,
                )}.`}
          </p>
        </ModalBody>
        <ModalFooter className="text-right">
          <Button color="primary" onClick={handleClickAcknowledge}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>
      <div className="page-title-box">
        <h4 className="page-title">Preview Transactions Import</h4>
      </div>
      <Card>
        <CardBody>
          <div className="text-sm-right mb-2">
            <Button
              disabled={isPending || selectedRows.length <= 0}
              color="primary"
              className="mr-1"
              onClick={handleValidSubmit}
            >
              Import {selectedRows.length} Selected {selectedRows.length === 1 ? 'Transaction' : 'Transactions'} (
              {formatCurrency(invoiceTotal)})
            </Button>
          </div>
          <FormServerErrors errors={errors} />
          <ImportPreviewTable
            loading={isPending}
            data={previewCsvTransactions}
            columns={columns}
            mode="checkbox"
            clickToSelect={true}
            setSelectedRows={setSelectedRows}
            selectedRows={selectedRows}
            nonSelectable={getNonSelectableRows()}
          />
        </CardBody>
      </Card>
    </>
  )
}
